import { render, staticRenderFns } from "./StaffManage.vue?vue&type=template&id=42e773d9"
import script from "./StaffManage.vue?vue&type=script&lang=js"
export * from "./StaffManage.vue?vue&type=script&lang=js"
import style0 from "./StaffManage.vue?vue&type=style&index=0&id=42e773d9&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports